import {TransactionErrorsFactory} from '../Errors/factory.js'
import {BuyerDataParamsRequest} from './BuyerDataParamsRequest.js'
import {CreateLoanIdTransactionsRequest} from './CreateLoanIdTransactionsRequest.js'
import {GetLoanCalculationsTransactionsRequest} from './GetLoanCalculationsTransactionsRequest.js'
import {GetLoanUrlB2CTransactionsRequest} from './GetLoanUrlB2CTransactionsRequest.js'
import {GetLoanUrlTransactionsRequest} from './GetLoanUrlTransactionsRequest.js'
import {GetTransactionParamsRequest} from './GetTransactionParamsRequest.js'
import {LoanCalculationsB2CTransactionsRequest} from './LoanCalculationsB2CTransactionsRequest.js'
import {PayOutParamsRequest} from './PayOutParamsRequest.js'
import {ReservationIdRequest} from './ReservationIdRequest.js'
import {ReservationRequest} from './ReservationRequest.js'
import {UpdateTransactionParamsRequest} from './UpdateTransactionParamsRequest.js'
import {UserFormDataRequest} from './UserFormDataRequest.js'

export class TransactionRequestsFactory {
  static getLoanUrlTransactionsRequest = params => new GetLoanUrlTransactionsRequest(params)

  static createLoanIdTransactionsRequest = ({adId, entry, fee, terms, withLifeInsurance, withGapInsurance}) => {
    CreateLoanIdTransactionsRequest.validate({
      adId,
      validationError: TransactionErrorsFactory.transactionError
    })
    return new CreateLoanIdTransactionsRequest({adId, entry, fee, terms, withLifeInsurance, withGapInsurance})
  }

  static getLoanUrlB2CTransactionsRequest = ({loanId}) => {
    GetLoanUrlB2CTransactionsRequest.validate({loanId, validationError: TransactionErrorsFactory.transactionError})
    return new GetLoanUrlB2CTransactionsRequest({loanId})
  }

  static getLoanCalculationsTransactionsRequest = ({entry, lender, plateRegistrationDate, price, terms}) =>
    new GetLoanCalculationsTransactionsRequest({
      entry,
      lender,
      plateRegistrationDate,
      price,
      terms
    })

  static getTransactionParamsRequest = ({adId, buyerId, sellerId}) =>
    new GetTransactionParamsRequest({adId, buyerId, sellerId})

  static updateTransactionParamsRequest = ({adId, buyerId, sellerId, status}) =>
    new UpdateTransactionParamsRequest({
      adId,
      buyerId,
      sellerId,
      status
    })

  static buyerDataParamsRequest = ({id, lastName, firstName, residence, mail}) => {
    BuyerDataParamsRequest.validate({
      id,
      lastName,
      firstName,
      residence,
      mail,
      validationError: TransactionErrorsFactory.buyerDataError
    })

    return new BuyerDataParamsRequest({
      id,
      lastName,
      firstName,
      residence,
      mail
    })
  }

  static payOutParamsRequest = ({adId, sellerId, buyerId, iban}) => {
    PayOutParamsRequest.validate({
      adId,
      sellerId,
      buyerId,
      iban,
      validationError: TransactionErrorsFactory.payOutError
    })

    return new PayOutParamsRequest({adId, sellerId, buyerId, iban})
  }

  static userFormDataRequest = ({adId, userId, name, lastName, email, phone}) => {
    UserFormDataRequest.validate({
      adId,
      userId,
      name,
      lastName,
      email,
      phone,
      validationError: TransactionErrorsFactory.userFormError
    })

    return new UserFormDataRequest({adId, userId, name, lastName, email, phone})
  }

  static reservationIdRequest = ({reservationId}) => {
    ReservationIdRequest.validate({reservationId, validationError: TransactionErrorsFactory.reservationIdError})
    return new ReservationIdRequest({reservationId})
  }

  static reservationRequest = ({reservationId, reservationState}) => {
    ReservationRequest.validate({reservationId, validationError: TransactionErrorsFactory.reservationIdError})
    return new ReservationRequest({reservationId, reservationState})
  }

  static loanCalculationsB2CTransactionsRequest = ({adId, entry, terms, withLifeInsurance, lender}) => {
    LoanCalculationsB2CTransactionsRequest.validate({
      adId,
      entry,
      terms,
      withLifeInsurance,
      lender,
      validationError: TransactionErrorsFactory.transactionError
    })
    return new LoanCalculationsB2CTransactionsRequest({adId, entry, terms, withLifeInsurance, lender})
  }
}
